import React, { Component } from 'react';
import {InputText} from 'primereact/inputtext';
import PropTypes from 'prop-types';


class CasInputText extends Component {
    
    static propTypes = {
        id:PropTypes.string,
        type:PropTypes.any,
        size:PropTypes.number,
        name:PropTypes.string.isRequired,
        value:PropTypes.any,
        disabled:PropTypes.bool,
        onChange:PropTypes.func,
        validateOnly:PropTypes.bool,
        tooltip: PropTypes.any,
        className: PropTypes.string,
        style: PropTypes.any,
        onInput:PropTypes.func,
        maxLength:PropTypes.number,
        tabindex:PropTypes.number,
        label:PropTypes.string,
        errorText:PropTypes.string,
        placeholder:PropTypes.string,
        icon: PropTypes.string,
    }

    static defaultProps = {
        disabled: false,
        id:'',
        name:'',
        value:'',
        maxLength:100,
        tabindex:1,
        label:"",
        errorText:"",
        placeholder:""
    };

 
    renderErrorText() {
      if(this.props.errorText){
        return(
          <small className="cas-inline-err-text p-d-block">{this.props.errorText}</small>
        );
      }
    }

    renderField() {
      const {
        id,
        type,
        name,
        size,
        value,
        disabled,
        onChange,
        tooltip,
        style,
        maxLength,
        tabindex,
        onFocus,
        onBlur,
        placeholder,
        onInput,
        icon
        
      } = this.props;
      let className = this.props.className;
      if(this.props.errorText){
        className = className + " p-invalid";
      }
      return (
        <InputText id={id} placeholder={placeholder} icon={icon} className={className}  type={type} size={size} value={value} name={name} onChange={onChange} disabled={disabled} 
         onInput={onInput} tooltip={tooltip} onFocus={onFocus} onBlur={onBlur} style={style} maxLength={maxLength}  tabIndex={tabindex} />
      )

    }

    render () {
      return (
        <div className="cas-input-field">
          {this.renderField()}
          {this.renderErrorText()}
        </div>
      )
    }

  }

export default CasInputText;
